module.exports = "<div class=\"text-center\">\r\n    <h3 class=\"color-maroon\">You are not authorized to perform this action.</h3>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/authentication/unauthorized.html
// module id = 135
// module chunks = 0